import _ from "underscore";
import $ from "jquery";
import render from "../render";
import {isTruthy, rgxTest, isPresent} from "../general";


const inputsSelector = "input, textarea, select";

const noop = ()=>{};

export function selectVal(el){
  let val = el.val();
  if(val === "-1"){
    val = "";
  }
  return val;
}

export function boolToHuman(val){
  if(isTruthy(val)){
    return "Yes";
  }
  else{
    return "No";
  }
}

export function toggleClassViaBool(el, cls, val){
  if(isTruthy(val)){
    el.addClass(cls);
  }
  else{
    el.removeClass(cls);
  }
}

export function ib(el){
  el.css({display: "inline-block"});
}

export function resetDisplay(el){
  el.css({display: ""});
}

export function insertTextAndClean(el, val){
  el.text(val);
}

export function allElements(elsMap){
  let out = $();

  _(elsMap).mapObject((el, k)=>{
    out = out.add(el);
  });
  return out;
}

export function formatAddress({address1, address2, city, state, zip, country}){
  const output = `${address1}
    ${address2}
    ${city},
    ${state}
    ${zip}
    ${country}`
    .replace(/ +(?= )/g,'');
  return output;
}

export function setDisabled(elsArr){
  _(elsArr).map((el)=>{
    el.prop("disabled", true);
  });
}

export function setEnabled(elsArr){
  _(elsArr).map((el)=>{
    el.prop("disabled", false);
  });
}

export function setDisabledClass(elsArr){
  _(elsArr).map((el)=>{
    el.addClass("disabled");
  });
}

export function setUniqNames(elsArr){
  _(elsArr).map((el)=>{
    el.attr("name", _.uuid());
  });
}

export function setUniqIds(elsArr){
  _(elsArr).map((el)=>{
    el.attr("id", _.uuid());
  });
}

export function setUniqNamesAndIds(elsArr){
  _(elsArr).map((el)=>{
    const id = _.uuid();
    el.attr("name", id);
    el.attr("id", id);
  });
}

export function setRequired(elsArr){
  _(elsArr).map((el)=>{
    el.addClass("isrequired");
  });
}

export function removeRequired(elsArr){
  _(elsArr).map((el)=>{
    el.removeClass("isrequired");
  });
}

export function setPhoneUs(elsArr, data){
  _(elsArr).map((el)=>{
    if(data=="+1"){
      el.addClass("phoneUS");
    }else{
      el.removeClass("phoneUS")
    }
    
  });
}

export function combineElements(arr){
  let output = $();
  _(arr).each((el)=>{
    output = output.add($(el));
  });
  return output;
}


export function setElementsFromScope(targetObj, elementsDict, scope){
  _(elementsDict).each((v, k)=>{
    // console.log(`${v} ${k}`)
    targetObj[k] = scope.find(v);
  });
}

export function swapClasses(el, {fromClasses, toClasses}){
  el.removeClass(fromClasses);
  el.addClass(toClasses);
}

export function swapClassesViaBool(el, trueClasses, falseClasses, val){
  if(isTruthy(val)){
    el.removeClass(falseClasses);
    el.addClass(trueClasses);
  }
  else{
    el.removeClass(trueClasses);
    el.addClass(falseClasses);
  }
}

export function hide(el){
  el.css('display', 'none');
}

export function show(el, opts={}){
  const displayType = opts.displayType || 'block';
  el.css('display', displayType);
}

export const enableInput = enableDisableInputFunc(false);
export const disableInput = enableDisableInputFunc(true);

function enableDisableInputFunc(status){
  return (el)=>{
    if(el.is(inputsSelector)){
      el.prop('disabled', status);
    }
    else{
      el = el.find(inputsSelector);
      el.prop('disabled', status);
    }
  }
}

export function handleDisplayFor(el, val){
  if(val){
    show(el);
  }
  else{
    hide(el);
  }
}

// make a v2 function of above
// so we can slowly port over old
// usage to new, more robust function
export function handleDisplayForV2(el, val){
  if(isTruthy(val)){
    resetDisplay(el);
  }
  else{
    hide(el);
  }
}

export function setCheckboxState(el, state){
  if(isTruthy(state)){
    el.prop('checked', true);
  }
  else{
    el.prop('checked', false);
  }
}

export const setRadioState = setCheckboxState;




export function setOptionsForSelect({selectElement, list, afterOptionCreate=noop, initialSelectValue=noop, valueDataKey="value", textDataKey="text"}){
  // fastest using context of keys and named function
  const optionsArr = _(list).map(setOptionViaData, {valueDataKey, textDataKey, afterOptionCreate});
  const options = combineElements(optionsArr);
  selectElement.append(options);
  let val;
  if(_.isFunction(initialSelectValue)){
    val = initialSelectValue(selectElement, list, options);
  }
  else{
    val = initialSelectValue;
  };
  val = (_.isRegExp(val) ? findDefaultOptionViaRgxVal(optionsArr, val) : val);
  selectElement.val(val);
}

function findDefaultOptionViaRgxVal(optionsArr, rgx){
  const option = _(optionsArr).find((option)=>{
    return rgxTest(rgx, option.val());
  });
  if(option){
    return option.val();
  }
  else{
    return null;
  }
}


function setOptionViaData(data){
  const {valueDataKey, textDataKey, afterOptionCreate} = this;
  const option = $('<option/>');
  option.val(data[valueDataKey]);
  option.text(data[textDataKey]);
  afterOptionCreate({option, data});
  return option;
}






export function insertValAndManageFocus(input, val){
  if(input.length){
    const inputWasFocused = input.is(":focus");
    const canGrabSelection = !input.is('[type="number"]');

    let origCaret;
    // if input was focused,
    // find out what part was focused
    //console.log('input was focused,', inputWasFocused);
    if(canGrabSelection && inputWasFocused){
      origCaret = input.range();
    }
    // then, always set the val
    // to updated val,
    // but also check if val
    // is undefined or null,
    // so we can set the val
    // to empty string
    if(_.isNull(val)  || _.isUndefined(val)){
      val = "";
    }

    // only insert value if:
    // the input was NOT focused
    // --- OR ----
    // you can ensure you are able to grab the selection
    // to refocus the previously-focused input
    if(!inputWasFocused || canGrabSelection){
      if(input.val() !== val){
        input.val(val);
      }
    }

    // now, if the input was originally
    // focused, we need to put the caret
    // back to where it was
    if(inputWasFocused && canGrabSelection){
      if(_.isNull(origCaret)  || _.isUndefined(origCaret)){
        input.focus();
      }
      else if(origCaret.start === origCaret.end){
        input.caret(origCaret.start);
      }
      else{
        input.range(origCaret.start, origCaret.end);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utilities/selectorHelpers/index.js